import angular from 'angular';
import batchCancelComponent from './batchCancel.component';

let batchCancelModule = angular.module('batchCancel', [])
  .component('batchCancel', batchCancelComponent);

export default batchCancelModule;



// WEBPACK FOOTER //
// ./app/components/batchCancel/batchCancel.js